export default "__VITE_ASSET__Cm82T4It__"